// extracted by mini-css-extract-plugin
module.exports = {"footerHr":"footer_footerHr__oClDt","footerDiv":"footer_footerDiv___x85a","footerA":"footer_footerA__j8a4a"};